import React, { Component } from 'react';

import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';

class LoginPage extends Component {
    goToRoute = route => {
        this.props.history.push(route);
    }
    render() {
        const { location: { pathname } } = this.props;
        const isRegister = pathname === '/register';
        return (
            <div className="login-container">
                <div className="login-text animated fadeInDown">
                    Missions Education Fund
                </div>
                { isRegister ?
                    <RegisterForm location={this.props.location} goToRoute={this.goToRoute} /> :
                    <LoginForm location={this.props.location} goToRoute={this.goToRoute} />
                }
            </div>
        )
    }
}

export default LoginPage;


// WEBPACK FOOTER //
// ./src/components/authentication/LoginPage.jsx